module.exports = __webpack_public_path__ + "static/media/icon_search_white.30ff516f.png";